import { FlowType } from "conversion_flows/types/scalars"
import {
  ActionExecutionType,
  ActionType,
} from "DealerApp/Settings/webModules/operations/getOptions"
import { getContext, setContext } from "svelte"
import IntegrationTypes from "website_script/constants/IntegrationTypes"
import { BuildUrlDataOutput } from "website_script/lib/buildModuleUrlData"
import { ElementData } from "website_script/lib/Parsers"

export type Flow = {
  lead_flow_id?: number
  flow_type: FlowType
  action_type: ActionType
  action_execution?: ActionExecutionType
  url?: string
  js_snippet?: string
  open_in_new_tab?: boolean
}
/**
 * Responsible for opening the root Modal and
 * triggering the appropriate lead flow.
 */
export type TriggerFlowFn = (
  flow: Flow,
  integrationType: IntegrationTypes,
  urlData?: Partial<BuildUrlDataOutput>,
  elData?: ElementData,
  leadId?: string | null,
  leadToken?: string | null
) => void

export type TriggerInputFormFlowFn = (
  flow: Flow,
  opts: {
    integrationType: IntegrationTypes
    urlData?: Partial<BuildUrlDataOutput>
    elData?: ElementData
    leadId?: string | null
    leadToken?: string | null
  }
) => void

export type TriggerSimpleFlowFn = (flow: Flow) => void

export type FlowsContext = {
  triggerFlow: TriggerFlowFn
}

export const setFlowsContext = ({ triggerFlow }: FlowsContext) => {
  setContext<FlowsContext>("flows", { triggerFlow })
}

export const getFlowsContext = () => {
  return getContext<FlowsContext>("flows")
}
